import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
// 货币符号随语言对应国家货币：ja→円(日元，后缀)、kr→₩(韩元)、zh→NT$(新台币)、en→$(美元)
Vue.prototype.$currency = function () {
  const map = { ja: '円', kr: '₩', zh: 'NT$', en: '$' };
  const locale = (this.$i18n && this.$i18n.locale) || localStorage.getItem('lang') || 'ja';
  return map[locale] || '$';
};
// 金额+货币符号统一格式化：日语"円"放金额后面（如 330000円），其余语言符号在前
Vue.prototype.$money = function (v) {
  const locale = (this.$i18n && this.$i18n.locale) || localStorage.getItem('lang') || 'ja';
  const val = (v === undefined || v === null || v === '') ? '0.00' : v;
  return locale === 'ja' ? `${val}${this.$currency()}` : `${this.$currency()}${val}`;
};
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const i18n = new VueI18n({
  globalInjection: true, 
  locale: localStorage.getItem("lang") || "ja", // 动态获取语言设置，默认为日语
  messages: {
    'zh': require('./assets/languages/zh.json'),
    'en': require('./assets/languages/en.json'),
    'ja': require('./assets/languages/ja.json'),
    'kr': require('./assets/languages/kr.json')
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
